const KNOWN_SIGNALS = new Set(["BUY", "SELL", "HOLD", "ERROR"]);

export function signalVariant(signal: string | null | undefined): string {
  const value = String(signal || "").toUpperCase();
  return KNOWN_SIGNALS.has(value) ? value.toLowerCase() : "unknown";
}

interface SignalPillProps {
  signal: string | null | undefined;
  size?: "sm" | "md";
}

export function SignalPill({ signal, size = "md" }: SignalPillProps) {
  const value = String(signal || "").toUpperCase();
  const variant = signalVariant(signal);
  return <span className={`sig-pill sig-${variant} sig-${size}`}>{value || "—"}</span>;
}
